import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import './LegalPage.css';
import useSEO from '../hooks/useSEO';

const LegalPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const API_BASE = process.env.REACT_APP_API_URL || '/public/api';
        const response = await fetch(`${API_BASE}/legal_pages.php?slug=${slug}`);
        if (response.ok) {
          const text = await response.text();
          const result = JSON.parse(text);
          if (result.success && result.data) {
            setPage(result.data);
          }
        }
      } catch (error) {
        console.error('Error fetching legal page:', error);
      } finally {
        setLoading(false);
      }
    };

    if (slug) {
      fetchPage();
    }
  }, [slug]);

  useSEO({
    title: page ? `${page.title} - Efruz İnşaat` : 'Yasal Sayfa - Efruz İnşaat',
    description: page ? page.title : 'Yasal sayfa içeriği',
    keywords: 'efruz inşaat, yasal sayfalar, gizlilik politikası, kullanım şartları'
  });

  if (loading) {
    return (
      <div className="legal-page">
        <div className="container">
          <div style={{ textAlign: 'center', padding: '100px 20px' }}>
            <p>Yükleniyor...</p>
          </div>
        </div>
      </div>
    );
  }

  if (!page) {
    return (
      <div className="legal-page">
        <div className="container">
          <div style={{ textAlign: 'center', padding: '100px 20px' }}>
            <h1>Sayfa Bulunamadı</h1>
            <p>Aradığınız sayfa bulunamadı.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="legal-page">
      <section className="page-title-section">
        <div className="container">
          <h1 className="page-title">{page.title}</h1>
        </div>
      </section>

      <section className="legal-content section-padding">
        <div className="container">
          <div className="legal-content-wrapper">
            <div 
              className="legal-text" 
              dangerouslySetInnerHTML={{ __html: page.content.replace(/\n/g, '<br>') }}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default LegalPage;

